export var BlastNetwork;
(function (BlastNetwork) {
    BlastNetwork["ETHEREUM_MAINNET"] = "eth-mainnet";
    BlastNetwork["OPTIMISM_MAINNET"] = "optimism-mainnet";
    BlastNetwork["ETHEREUM_GOERLI"] = "eth-goerli";
    BlastNetwork["OPTIMISM_GOERLI"] = "optimism-goerli";
    BlastNetwork["BASE_GOERLI"] = "base-goerli";
})(BlastNetwork || (BlastNetwork = {}));
export const BLAST_NETWORK_LOOKUP = {
    1: BlastNetwork.ETHEREUM_MAINNET,
    5: BlastNetwork.ETHEREUM_GOERLI,
    10: BlastNetwork.OPTIMISM_MAINNET,
    420: BlastNetwork.OPTIMISM_GOERLI,
    84531: BlastNetwork.BASE_GOERLI,
};
